export default __webpack_public_path__ + "img/c5bb7d9b181a01fa942230535713f5ef.png";